import React from "react";
import PropTypes from "prop-types";
import { FluentBadge } from "../../../../components/FluentUI/Fluent-Badge";
import { FluentTooltip } from "../../../../components/FluentUI/Fluent-Tooltip";
import "./organization.scss";

const CustomBadge = ({ name  }) => {
    return (
        <FluentTooltip
            target={
                <div className="organization-badgename">
                    <FluentBadge
                        shape="rounded"
                        appearance="tint"
                        size="extra-large"
                        text={name??""}
                    />
                </div>
            }
            text={name??""}
        />
    );
};

CustomBadge.propTypes = {
    name: PropTypes.string,
};


export default CustomBadge;
